import { CONTENTFUL_APP_URL } from './constants';
import { getMetaContentfulEnv } from './get-contentful-env';

export const buildContentfulDeepLink = (spaceId: string, entryId: string) =>
    `${CONTENTFUL_APP_URL}/${spaceId}/environments/${getMetaContentfulEnv()}/entries/${entryId}`;
